import { api } from '../../lib/api';

export interface AppNotification {
  id: string;
  category: string;
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface ChatMessage {
  id: string;
  body: string;
  type: 'TEXT' | 'SYSTEM';
  isMine: boolean;
  isSystem: boolean;
  senderName: string | null;
  createdAt: string;
}

export const notificationKeys = {
  list: ['notifications'] as const,
  unread: ['notifications', 'unread'] as const,
  chat: (bookingId: string) => ['chat', bookingId] as const,
};

export async function fetchNotifications(): Promise<AppNotification[]> {
  const response = await api.get<AppNotification[]>('/notifications');
  return response.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const response = await api.get<{ count: number }>('/notifications/unread-count');
  return response.data.count;
}

export async function markRead(id: string): Promise<void> {
  await api.post(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await api.post('/notifications/read-all');
}

export async function openChat(bookingId: string): Promise<{ otherParty: string }> {
  const response = await api.post<{ otherParty: string }>(`/bookings/${bookingId}/chat`);
  return response.data;
}

export async function fetchMessages(bookingId: string): Promise<ChatMessage[]> {
  const response = await api.get<ChatMessage[]>(`/bookings/${bookingId}/chat/messages`);
  return response.data;
}

export async function sendMessage(bookingId: string, body: string): Promise<ChatMessage> {
  const response = await api.post<ChatMessage>(`/bookings/${bookingId}/chat/messages`, { body });
  return response.data;
}

// --- the inbox ---------------------------------------------------------------

export interface InboxRow {
  bookingId: string;
  reference: string;
  bookingStatus: string;
  route: string;
  departureAt: string;
  otherParty: string | null;
  otherPartyPhotoUrl: string | null;
  lastMessage: { body: string; createdAt: string } | null;
  unread: number;
}

export async function fetchInbox(): Promise<InboxRow[]> {
  const response = await api.get<InboxRow[]>('/messages');
  return response.data;
}
